export const REGISTER_SELLER_SUCCESS = "REGISTER_SELLER_SUCCESS";
export const GET_APPROVED_ORDERS = "GET_APPROVED_ORDERS";
export const GET_PENDING_ORDERS = "GET_PENDING_ORDERS";
export const GET_CANCELED_ORDERS = "GET_CANCELED_ORDERS";
export const GET_ALL_ORDERS = "GET_ALL_ORDERS";
export const GET_ORDER_STATS = "GET_ORDER_STATS";
export const GET_SELLER_PENDING_ORDERS = "GET_SELLER_PENDING_ORDERS";
export const GET_ONE_ORDER = "GET_ONE_ORDER";
export const GET_ORDER_FAILED = "GET_ORDER_FAILED";
